import React, { useEffect, useState } from 'react'
import { useSelector } from "src/stateManagement/redux";
import { DataGrid, GridColDef, GridRowsProp } from '@mui/x-data-grid';
import Grid from "@mui/material/Grid2";
import "../trendStyles.scss";
import moment from "moment";

export interface ITableProps {
    mergedActiveProfile: any,
    dataToTable: any[],
    setdataToTable: any,
    filteredData: any[],
    filters: any[]
}


export const TableCustom = ({ mergedActiveProfile, dataToTable, setdataToTable, filteredData, filters }: ITableProps) => {

    const { fieldActivities } = useSelector((state) => state.location);



    const [dataColumns, setDataColumns] = useState<GridColDef[]>([])

    const paginationModel = { page: 0, pageSize: 10 };


    useEffect(() => {

        if (mergedActiveProfile?.config) {

            const datToTable: any[] = []

            let sortActivities: any[] = [...fieldActivities].sort((a: any, b: any) => new Date(b.executedDate).getTime() - new Date(a.executedDate).getTime());

            for (const filter of filters) {
                const filterData = filteredData.find(f => f.name === filter.name);
                if (filterData) {
                    if (filterData.action === 'greater') {
                        sortActivities = sortActivities.filter((x) => x[filter.field] > filterData.value);
                    } else if (filterData.action === 'less') {
                        sortActivities = sortActivities.filter((x) => x[filter.field] < filterData.value);
                    } else if (filterData.action === 'equal') {
                        sortActivities = sortActivities.filter((x) => x[filter.field] === filterData.value);
                    } else if (filterData.action === 'different') {
                        sortActivities = sortActivities.filter((x) => x[filter.field] !== filterData.value);
                    } else if (filterData.action === 'dissable') {
                        sortActivities = sortActivities || [];
                    } else if (filterData.action === 'include' && filterData.value.length > 0) {
                        sortActivities = sortActivities.filter((x) => filterData.value.includes(x[filter.field]));
                    } else if (filterData.action === 'equalAfter') {
                        sortActivities = sortActivities.filter((x) => {
                            const locationDate = moment(x.executedDate);
                            return locationDate.isSameOrAfter(filterData.value, 'day')
                        });
                    } else if (filterData.action === 'equalBefore') {
                        sortActivities = sortActivities.filter((x) => {
                            const locationDate = moment(x.executedDate)
                            return locationDate.isSameOrBefore(filterData.value, 'day')
                        });
                    }
                }
            }

            for (const act of sortActivities) {
                const elementToAdd: any = {
                    fecha: act?.executedDate,
                    id: act?.fieldActivityId,
                }

                for (const config of mergedActiveProfile?.config) {
                    const variableID = config?.variableId

                    const variable = act?.variables?.find((v: any) => v?.id === variableID);



                    let value = variable?.value !== undefined && variable?.value !== null ? variable?.value : "S/I";

                    if (value !== "S/I") {
                        try {
                            value = parseFloat(value);
                        } catch (error) {

                        }
                    }

                    const minSetpointValue = config?.min
                    const maxSetpointValue = config?.max
                    const averageSetpointValue = config?.average

                    let state = 'normal'

                    if (typeof value === "number") {
                        if (value > maxSetpointValue || value < minSetpointValue) {
                            state = "out of range"
                        } else if (value < (1.2 * averageSetpointValue) && value > (0.8 * averageSetpointValue)) {
                            state = "normal"
                        } else if (value > (0.85 * maxSetpointValue) || value < (1.15 * minSetpointValue)) {
                            state = "close to limit"
                        }else {
                            state = "evaluate"
                        }
                    } else {
                        state = "noNumber"
                    }

                    elementToAdd[`${config?.variableName}`] = value;
                    elementToAdd[`${config?.variableName}_state`] = state;
                }

                datToTable.push(elementToAdd)
            }
            setdataToTable(datToTable)

            const headers: GridColDef[] = [
                { field: 'fecha', headerName: 'Fecha', flex: 0.1 },
            ]

            for (const element of mergedActiveProfile?.config) {
                console.log("element", element?.variableName);
                const header: GridColDef = {
                    field: element?.variableName,
                    headerName: element?.variableName,
                    width: 230,
                    renderCell: (params) => {

                        let color = "white"

                        if (params.row[`${element?.variableName}_state`] === "out of range") {
                            color = "#F44336"
                        } else if (params.row[`${element?.variableName}_state`] === "close to limit") {
                            color = "#FFCA28"
                        } else if (params.row[`${element?.variableName}_state`] === "normal") {
                            color = "#46B406"
                        }

                        return (
                            <div style={{
                                backgroundColor: color,
                                width: "100%",
                                height: "100%",
                                borderRadius: "5px",
                                color: color !== "white" ? "#fff" : "rgba(145, 142, 142, 0.6)",
                                textAlign: "center",
                                fontWeight: "bold",
                            }}>
                                {params.value}
                            </div>
                        )
                    }
                }
                headers.push(header)
            }

            setDataColumns(headers)
        }

    }, [fieldActivities, mergedActiveProfile, filteredData])

    const rows: GridRowsProp = dataToTable.map((item) => {
        return {
            ...item,
            fecha: moment(item.fecha).format("DD-MM-YYYY"),
        }
    })

    return (
        <Grid className="table-container">
            <DataGrid
                rows={rows}
                columns={dataColumns}
                initialState={{
                    pagination: { paginationModel },
                }}
                pageSizeOptions={[10, 20, 50, 100]}
                checkboxSelection={false}
                sx={{
                    border: 0,
                    "& .MuiDataGrid-columnHeader": {
                        backgroundColor: "#316EBC",
                        color: "#fff",
                        fontWeight: "bold",
                    },
                }}
                getRowId={(row) => row.id}
            />
        </Grid>
    );
}

